module.exports = __webpack_public_path__ + "img/promobox_03m.8cb2de82.svg";